import React from "react"
// import logo from "./logo.svg"
import { Counter } from "../../features/counter/Counter"
import ResourcesGrid from "../../features/resources-grid/ResourcesGrid"
//import ResourcesCategories from "../../features/resources-categories/ResourcesCategories"
import ResourcesLayout from "../../features/resources-grid/ResourcesLayout"
import Grid from "@mui/material/Grid"
import "./Resources.css"
import background from "../success-stories/background.png"

function Resources() {
  return (
    <div
      className="App"
      style={{ height: "100vh", backgroundImage: `url(${background})` }}
    >
      <div
        className="resourcePage"
        style={{ backgroundImage: `url(${background})` }}
      >
        <div className="resource-title">Resources</div>

        <ResourcesLayout />
      </div>
    </div>
  )
}

export default Resources
